module.exports = __webpack_public_path__ + "assets/img/7-2.c515a630.png";